'use client';

import { dynamic } from '#/utils/dynamic';

export const DynamicNotFoundPage = dynamic(
  () =>
    import('./NotFoundPage').then((module) => ({
      default: module.NotFoundPage,
    })),
  { strategy: 'always' },
);
